export default __webpack_public_path__ + "static/AWS_Buildon_2019_2-1b414f4c293f459f83fb675687e0d915.jpg";